module.exports = __webpack_public_path__ + "img/large-processing.4de5b48f.gif";